__turbopack_context__.v({
  "grid": "EFfm6q_grid",
  "gridCapped": "EFfm6q_gridCapped",
  "item": "EFfm6q_item",
  "moreBtn": "EFfm6q_moreBtn",
  "moreWrap": "EFfm6q_moreWrap",
});
